/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToApiResponse, convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminWorkerJobsResp,
    AdminWorkerJobsRespFromJSON,
    AdminWorkerJobsRespToJSON,
    AdminWorkerRunReq,
    AdminWorkerRunReqFromJSON,
    AdminWorkerRunReqToJSON,
    AdminWorkerRunResp,
    AdminWorkerRunRespFromJSON,
    AdminWorkerRunRespToJSON,
    AdminWorkerStatusResp,
    AdminWorkerStatusRespFromJSON,
    AdminWorkerStatusRespToJSON,
} from '../models';

export interface AdminWorkerApiAdminRunWorkerJobRequest {
    params: AdminWorkerRunReq;
}

export interface AdminWorkerApiAdminWorkerJobsRequest {
    state?: AdminWorkerJobsStateEnum;
    kind?: string;
    limit?: number;
    offset?: number;
}

export function createAdminPauseWorkerPath(): string {
    return `/admin/worker/pause`;
}
export function createAdminPauseWorkerFullPath(): string {
    return runtime.BASE_PATH + `/admin/worker/pause`;
}
export function createAdminResumeWorkerPath(): string {
    return `/admin/worker/resume`;
}
export function createAdminResumeWorkerFullPath(): string {
    return runtime.BASE_PATH + `/admin/worker/resume`;
}
export function createAdminRunWorkerJobPath(): string {
    return `/admin/worker/run`;
}
export function createAdminRunWorkerJobFullPath(): string {
    return runtime.BASE_PATH + `/admin/worker/run`;
}
export function createAdminWorkerJobsPath(): string {
    return `/admin/worker/jobs`;
}
export function createAdminWorkerJobsFullPath(): string {
    return runtime.BASE_PATH + `/admin/worker/jobs`;
}
export function createAdminWorkerStatusPath(): string {
    return `/admin/worker/status`;
}
export function createAdminWorkerStatusFullPath(): string {
    return runtime.BASE_PATH + `/admin/worker/status`;
}

/**
 *
 */
export class AdminWorkerApi extends runtime.BaseAPI {
    /**
     * The worker stops taking new jobs; jobs already running finish. Scheduled jobs keep queueing and run after Resume.
     * Pause the worker queue
     */
    async adminPauseWorker(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminPauseWorkerPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * The worker takes jobs again.
     * Resume the worker queue
     */
    async adminResumeWorker(initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminResumeWorkerPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(!response ? undefined : new runtime.VoidApiResponse(response));
    }
    /**
     * Queues a scheduler job now: market_refresh (every product whose eBay market is not fresh), listing_checks (own eBay listings not checked for a day), recompute_all (analytics of every product in sale) or ebay_orders (eBay orders of listings published from the admin). It runs when the worker is running and not paused.
     * Run a worker job now
     */
    async adminRunWorkerJob(
        requestParameters: AdminWorkerApiAdminRunWorkerJobRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminWorkerRunResp>> {
        if (requestParameters?.params === null || requestParameters?.params === undefined) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter requestParameters.params was null or undefined when calling adminRunWorkerJob.'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminRunWorkerJobPath(),
                    method: 'POST',
                    headers: headerParameters,
                    query: queryParameters,
                    body: AdminWorkerRunReqToJSON(requestParameters?.params),
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminWorkerRunRespFromJSON(jsonValue))
        );
    }
    /**
     * Jobs of the worker queue, newest first.
     * Background worker jobs
     */
    async adminWorkerJobs(
        requestParameters?: AdminWorkerApiAdminWorkerJobsRequest,
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminWorkerJobsResp>> {
        const queryParameters: any = {};

        if (requestParameters?.state !== undefined) {
            queryParameters['state'] = requestParameters.state;
        }

        if (requestParameters?.kind !== undefined) {
            queryParameters['kind'] = requestParameters.kind;
        }

        if (requestParameters?.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters?.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminWorkerJobsPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminWorkerJobsRespFromJSON(jsonValue))
        );
    }
    /**
     * Whether the worker process is running, job stats per kind (queued, running, completed and failed in 24 hours) and how much of the catalog has fresh market data.
     * Background worker status
     */
    async adminWorkerStatus(
        initOverrides?: RequestInit | runtime.InitOverideFunction
    ): Promise<ApiResponse<AdminWorkerStatusResp>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters['Authorization'] = `Bearer ${this.configuration.apiKey('Authorization')}`; // Bearer authentication
        }

        let response: Response | undefined;

        try {
            response = await this.request(
                {
                    path: createAdminWorkerStatusPath(),
                    method: 'GET',
                    headers: headerParameters,
                    query: queryParameters,
                },
                initOverrides
            );
        } catch (e) {
            // Intentionally ignored.
        }

        return convertFetchResponseToApiResponse(
            !response
                ? undefined
                : new runtime.JSONApiResponse(response, (jsonValue) => AdminWorkerStatusRespFromJSON(jsonValue))
        );
    }
}

/**
 * @export
 */
export const AdminWorkerJobsStateEnum = {
    available: 'available',
    scheduled: 'scheduled',
    pending: 'pending',
    running: 'running',
    retryable: 'retryable',
    completed: 'completed',
    discarded: 'discarded',
    cancelled: 'cancelled',
} as const;
export type AdminWorkerJobsStateEnum = (typeof AdminWorkerJobsStateEnum)[keyof typeof AdminWorkerJobsStateEnum];
